import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "mt-2 pb-6" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "overflow-hidden" }
const _hoisted_5 = { class: "mx-4 text-sm" }
const _hoisted_6 = {
  key: 0,
  class: "px-6 py-4 text-center"
}

import { ref, h, computed, reactive, watch } from "vue";
import { useRoute } from "vue-router";
import { useSidebar } from "../../hooks/useSidebar";
import { usePermissions } from "@/stores/usePermissions";

type MenuItem = {
  name: string;
  label: string;
  to: string;
  icon: typeof HomeIcon;
  permission?: string;
  /** Si varios, basta con uno (útil cuando en BD aún no existe `pedidosPendientes` pero sí `pedidosPagados`). */
  permissions?: string[];
};

// ==== Menú dinámico con permisos ====
const STORAGE_KEY = "nova:sidebar:expanded";


export default /*@__PURE__*/_defineComponent({
  __name: 'AppSidebar',
  setup(__props) {

const { isOpen } = useSidebar();
const { hasPermission, hasAnyPermission } = usePermissions();
const route = useRoute();

const activeClass = ref(
  "bg-red-600 bg-opacity-25 text-gray-100 border-red-500"
);
const inactiveClass = ref(
  "border-slate-900 text-slate-500 hover:bg-red-600 hover:bg-opacity-25 hover:text-gray-100"
);

function handleMenuClick() {
  if (isOpen.value && window.innerWidth < 1024) {
    isOpen.value = false;
  }
}

// ==== ÍCONOS usando render functions ====
const HomeIcon = (props: any) =>
  h(
    "svg",
    {
      fill: "none",
      stroke: "currentColor",
      viewBox: "0 0 24 24",
      ...props,
    },
    [
      h("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6",
      }),
    ]
  );

const BoxIcon = (props: any) =>
  h(
    "svg",
    {
      fill: "none",
      stroke: "currentColor",
      viewBox: "0 0 24 24",
      ...props,
    },
    [
      h("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4",
      }),
    ]
  );

const TagIcon = (props: any) =>
  h(
    "svg",
    {
      fill: "none",
      stroke: "currentColor",
      viewBox: "0 0 24 24",
      ...props,
    },
    [
      h("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z",
      }),
    ]
  );

const TruckIcon = (props: any) =>
  h(
    "svg",
    {
      fill: "none",
      stroke: "currentColor",
      viewBox: "0 0 24 24",
      ...props,
    },
    [
      h("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0",
      }),
    ]
  );

const ClipboardIcon = (props: any) =>
  h(
    "svg",
    {
      fill: "none",
      stroke: "currentColor",
      viewBox: "0 0 24 24",
      ...props,
    },
    [
      h("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2",
      }),
    ]
  );

/** Página Nosotros / contenido web */
const DocumentPageIcon = (props: any) =>
  h(
    "svg",
    {
      fill: "none",
      stroke: "currentColor",
      viewBox: "0 0 24 24",
      ...props,
    },
    [
      h("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z",
      }),
    ]
  );

/** Ítem de menú: `permission` (uno) o `permissions` (cualquiera). */
const menu = ref<{ title: string; items: MenuItem[] }[]>([
  {
    title: "GENERAL",
    items: [
      {
        name: "Dashboard",
        label: "Dashboard",
        to: "/dashboard",
        icon: HomeIcon,
        permission: "baret_navbar:dashboard",
      },
    ],
  },
  {
    title: "CONTENIDO DEL SITIO WEB",
    items: [
      {
        name: "ContenidoSitio",
        label: "Datos del sitio",
        to: "/contenido/sitio",
        icon: DocumentPageIcon,
        permission: "baret_navbar:dashboard",
      },
      {
        name: "ContenidoNosotros",
        label: "Página Nosotros",
        to: "/contenido/nosotros",
        icon: DocumentPageIcon,
        permission: "baret_navbar:dashboard",
      },
    ],
  },
  {
    title: "GESTIÓN DE PRODUCTOS",
    items: [
      {
        name: "Productos",
        label: "Productos",
        to: "/productos",
        icon: BoxIcon,
        permission: "baret_navbar:productos",
      },
      {
        name: "Categorías",
        label: "Categorías",
        to: "/productos/categorias",
        icon: TagIcon,
        permission: "baret_navbar:categorias",
      },
      {
        name: "Marcas",
        label: "Marcas de producto",
        to: "/productos/marcas",
        icon: ClipboardIcon,
        permission: "baret_navbar:marcasProductos",
      },
      {
        name: "Proveedores",
        label: "Proveedores",
        to: "/productos/proveedores",
        icon: ClipboardIcon,
        permission: "baret_navbar:proveedores",
      },
    ],
  },
  {
    title: "GESTIÓN DE VEHÍCULOS",
    items: [
      {
        name: "MarcaVehiculos",
        label: "Marcas de vehículo",
        to: "/vehiculos/marca",
        icon: TruckIcon,
        permission: "baret_navbar:marcasVehiculos",
      },
      {
        name: "ModelosVehiculos",
        label: "Modelos",
        to: "/vehiculos/modelos",
        icon: TruckIcon,
        permission: "baret_navbar:modelosVehiculos",
      },
    ],
  },
  {
    title: "GESTIÓN DE PEDIDOS",
    items: [
      {
        name: "PedidosPendientes",
        label: "Pendientes",
        to: "/pedidos/pendientes",
        icon: ClipboardIcon,
        permissions: [
          "baret_navbar:pedidosPendientes",
          "baret_navbar:pedidosPagados",
        ],
      },
      {
        name: "PedidosPagados",
        label: "Pagados",
        to: "/pedidos/pagados",
        icon: ClipboardIcon,
        permission: "baret_navbar:pedidosPagados",
      },
      {
        name: "PedidosCompletados",
        label: "Completados",
        to: "/pedidos/completados",
        icon: ClipboardIcon,
        permission: "baret_navbar:pedidosCompletados",
      },
    ],
  },
]);

// Computed para filtrar el menú según permisos
const filteredMenu = computed(() => {
  return menu.value
    .map((section) => ({
      ...section,
      items: section.items.filter((item) => {
        if (item.permissions?.length) {
          return hasAnyPermission(item.permissions);
        }
        if (item.permission) {
          return hasPermission(item.permission);
        }
        return true;
      }),
    }))
    .filter((section) => section.items.length > 0); // Solo mostrar secciones con items
});

// ==== Estado de secciones colapsables ====
// Persistimos el estado entre recargas para que la UX sea consistente.
function loadExpanded(): Record<string, boolean> {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed === "object") return parsed as Record<string, boolean>;
  } catch {
    /* ignorar */
  }
  return {};
}

const expandedMap = reactive<Record<string, boolean>>(loadExpanded());

function persist() {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(expandedMap));
  } catch {
    /* ignorar */
  }
}

function isExpanded(title: string): boolean {
  // Primer render por sección: por defecto expandido si no hay decisión previa.
  if (!(title in expandedMap)) return true;
  return expandedMap[title];
}

function toggleSection(title: string) {
  expandedMap[title] = !isExpanded(title);
  persist();
}

// Si el usuario navega a una ruta dentro de una sección colapsada,
// expandimos automáticamente esa sección.
watch(
  () => route.name,
  (currentName) => {
    if (!currentName) return;
    for (const section of filteredMenu.value) {
      if (section.items.some((it) => it.name === currentName)) {
        if (expandedMap[section.title] === false) {
          expandedMap[section.title] = true;
          persist();
        }
        break;
      }
    }
  },
  { immediate: true },
);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([_unref(isOpen) ? 'block' : 'hidden', "fixed inset-0 z-20 transition-opacity bg-black opacity-50 lg:hidden"]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (isOpen.value = false))
    }, null, 2),
    _createElementVNode("div", {
      class: _normalizeClass([_unref(isOpen) ? 'translate-x-0 ease-out' : '-translate-x-full ease-in', "fixed inset-y-0 left-0 z-30 w-64 overflow-y-auto transition duration-300 transform bg-slate-900 lg:translate-x-0 lg:static lg:inset-0"])
    }, [
      _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"flex items-center justify-center mt-8 px-4\"><div class=\"flex flex-col items-center\"><span class=\"text-2xl font-bold text-white tracking-wide\">Nova</span><span class=\"text-xs text-slate-400 mt-1\">Panel de administración</span></div></div><div class=\"mt-6 mb-4 mx-6\"><div class=\"h-px bg-gradient-to-r from-transparent via-gray-700 to-transparent\"></div></div>", 2)),
      _createElementVNode("nav", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredMenu.value, (section) => {
          return (_openBlock(), _createElementBlock("div", {
            key: section.title,
            class: "mb-1"
          }, [
            _createElementVNode("button", {
              type: "button",
              class: "flex w-full items-center justify-between px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-gray-400 hover:text-gray-200",
              onClick: ($event: any) => (toggleSection(section.title))
            }, [
              _createElementVNode("span", null, _toDisplayString(section.title), 1),
              (_openBlock(), _createElementBlock("svg", {
                class: _normalizeClass(["h-4 w-4 transition-transform duration-200", { 'rotate-180': isExpanded(section.title) }]),
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24"
              }, [...(_cache[1] || (_cache[1] = [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M19 9l-7 7-7-7"
                }, null, -1)
              ]))], 2))
            ], 8, _hoisted_3),
            _createVNode(_Transition, {
              "enter-active-class": "transition-all duration-200 ease-out",
              "leave-active-class": "transition-all duration-150 ease-in",
              "enter-from-class": "opacity-0 max-h-0",
              "enter-to-class": "opacity-100 max-h-[1000px]",
              "leave-from-class": "opacity-100 max-h-[1000px]",
              "leave-to-class": "opacity-0 max-h-0"
            }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("div", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.items, (item) => {
                    return (_openBlock(), _createBlock(_component_router_link, {
                      key: item.name,
                      to: item.to,
                      class: _normalizeClass(["flex items-center px-6 py-2 mt-1 duration-200 border-l-4", [_ctx.$route.name === item.name ? activeClass.value : inactiveClass.value]]),
                      onClick: handleMenuClick
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), { class: "w-5 h-5" })),
                        _createElementVNode("span", _hoisted_5, _toDisplayString(item.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["to", "class"]))
                  }), 128))
                ], 512), [
                  [_vShow, isExpanded(section.title)]
                ])
              ]),
              _: 2
            }, 1024)
          ]))
        }), 128)),
        (filteredMenu.value.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[2] || (_cache[2] = [
              _createElementVNode("p", { class: "text-sm text-gray-400" }, "No tienes permisos asignados", -1)
            ]))]))
          : _createCommentVNode("", true)
      ])
    ], 2)
  ]))
}
}

})